.gameLogWrapper {
  background-color: var(--ds-poker-green-darkest);
  border-radius: 16px;
  padding: 4px 8px;

  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
}

.scrollableArea {
  /* fixed width because autoscroll stuff gets wacky when this is resizeable
    (onScroll is called when it resizes, before componentDidUpdate -_-)
  */
  width: 250px;
  min-width: 250px;
  overflow: scroll;

  max-height: min(40vh, 420px);

  & > div {
    padding-top: 4px;
  }

  & > div:nth-child(2n) {
    background-color: var(--ds-poker-green-darker);
  }

  & > div:nth-child(2n-1) {
  }

  & > div:hover {
    background-color: var(--ds-poker-green-lighter);
  }
}

.collapseButton {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;

  width: 100%;

  &:hover svg {
    color: var(--ds-white);
  }

  cursor: pointer;
  & svg {
    margin-left: 4px;
  }

  padding: 4px 0;
}
